import React, { useEffect, useMemo } from "react";
import { useAppSelector } from "../../../Store";
import { Graph_QL, useSection } from "../../../Services";
import { SelectFieldOption_Values, ValueType } from "../../../Definitions";
import { UndefinedOptions } from "./useSelectOptions";

export const useSectionOptions = (includeUndefinedOption?: UndefinedOptions, systemId?: number, sectionId?: number,) => {
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const domain = useMemo(() => Graph_QL.ObjToString({ domain: farm }), [farm]);
  const connection = useMemo(() => Graph_QL.create({ domain: farm }), [farm]);

  const { call: getLfSectionInfo, data: sectionState } = useSection(connection);

  useEffect(() => {
    getLfSectionInfo({ fetchAmount: 500 })
  }, []);

  const sectionOptions: ValueType[] = useMemo(() => {
    if (sectionState && sectionState[domain]) {
      return sectionState[domain].data
        .filter(section => systemId === undefined || section.system_id === systemId)
        .map(section => ({
          label: section.name,
          id: section.section_id
        })) 
    }
    return []
  }, [domain, sectionState, systemId])

  const allSectionOptions: SelectFieldOption_Values[] = useMemo(() => {
    if (sectionState && sectionState[domain]) {
      return sectionState[domain].data
        .map(section => ({
          label: section.name,
          id: section.section_id
        })) 
    }
    return []
  }, [domain, sectionState])
  
  const locationOptions: SelectFieldOption_Values[] = useMemo(() => {
    if (sectionState && sectionState[domain]) {
      const locations = sectionState[domain].data
        .filter(section => systemId === undefined || section.system_id === systemId)
        .filter(section => sectionId === undefined || section.section_id === sectionId)
        .flatMap(section => section.section_locations)
        .map(({ name, location_id }) => ({ label: name, id: location_id }));

      if (includeUndefinedOption === UndefinedOptions.undefined) {
        return [{ label: "no location", id: null }, ...locations];
      } else if (includeUndefinedOption === UndefinedOptions.nan) {
        return [{ label: "no location", id: NaN }, ...locations];
      }

      return locations;
    }
    return includeUndefinedOption === UndefinedOptions.undefined ? [{ label: "No location", id: null }] : includeUndefinedOption === UndefinedOptions.nan ? [{ label: "No location", id: NaN }] : [];
  }, [sectionState, domain, includeUndefinedOption, systemId, sectionId]);

  return {sectionOptions, allSectionOptions, locationOptions};
};
